import React, { useState } from "react";
import SeeMore from "../../../../SeeMore/SeeMore";
import playButton from "../../../../../assets/icons/play-button.svg";
import { createFragmentContainer, graphql, useMutation } from "react-relay";

const DELETE_PODCAST = graphql`
  mutation PodcastListDeleteMutation($input: DeletePodcastInput!) {
    deletePodcast(input: $input) {
      success
    }
  }
`;

function PodcastList(props) {
  const [deletedPodcasts, setDeletedPodcasts] = useState([]);

  const [deletePodcast] = useMutation(DELETE_PODCAST);

  return (
    <div className="podcast-list-container">
      <h2 className="podcast-list-header">Available Episodes</h2>
      {props.podcasts.map((podcast) => {
        if (deletedPodcasts.includes(podcast.id)) {
          return;
        }

        return (
          <ul className="podcast-list" key={podcast.id}>
            <li className="podcast-list-item">
              <div className="podcast-list-content">
                <div className="podcast-list-content-pub-date">
                  {podcast.prettyPubDate}
                </div>
                <div className="podcast-list-content-title">
                  {podcast.title}
                  {props.isAdmin ? (
                    <>
                      {" "}
                      <button
                        onClick={() => {
                          if (
                            confirm(
                              `Are you sure you want to delete podcast "${podcast.title}"?`
                            )
                          ) {
                            deletePodcast({
                              variables: { input: { podcastId: podcast.id } },
                              onCompleted: () => {
                                setDeletedPodcasts((prevState) => {
                                  prevState.push(podcast.id);

                                  return [...prevState];
                                });
                              },
                            });
                          }
                        }}
                      >
                        Delete Podcast
                      </button>
                    </>
                  ) : null}
                </div>
                <div className="podcast-list-content-description">
                  <SeeMore text={podcast.description} length={100} />
                </div>
                <button
                  className="podcast-list-content-play"
                  onClick={(e) => props.setActivePodcast(e, podcast)}
                >
                  <img
                    className="podcast-list-content-play-icon"
                    src={playButton}
                    alt={""}
                  />
                  <span className="podcast-list-content-runtime">
                    {podcast.prettyDuration}
                  </span>
                </button>
              </div>
            </li>
            <hr className="podcast-list-rule" />
          </ul>
        );
      })}
    </div>
  );
}

export default createFragmentContainer(PodcastList, {
  podcasts: graphql`
    fragment PodcastList_podcasts on PodcastType @relay(plural: true) {
      ...PodcastPlayer_podcast
    }
  `,
});
